import Tabs from '@/common/components/Tabs';
import { useClientUser } from '@/features/users/hooks/useClientUser';
import { Link, useParams } from 'react-router-dom';
import { userTabs } from '../../constants/tabs.constant';
import Button from '@/common/components/Button';
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper';
import { useCurrentTabInfo } from '../../../../common/hooks/useCurrentTabInfo';
import { useMineCompany } from '@/features/company/hooks/useMineCompany';
import GoBackButton from '@/common/components/GoBackButton';
import Skeleton from '@/common/components/Skeleton';

const Show = () => {
  const { id: userId } = useParams();

  const {
    data: clientUserData,
    isPending: clientUserIsPending,
    error: clientUserError = {} as any,
    refetch: refetchClientUser,
  } = useClientUser({ id: userId || '' });

  const {
    data: companyData,
    isPending: companyDataIsPending,
  } = useMineCompany();

  if (!userId) {
    return null;
  }

  const disableUpdateButton = clientUserIsPending || clientUserError?.status === 403 || !clientUserData;

  const tabsList = userTabs(userId, companyData);

  const { currentTab } = useCurrentTabInfo(tabsList);

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={clientUserError?.status}
      refetchFunction={refetchClientUser}
    >
      <div>
        <div className="flex justify-between items-center mb-6">
          <div className="flex gap-4 items-center">
            <GoBackButton
              fallback='/users'
              searchLastRouteFromReference={`/users/${userId}`}
            />

            {clientUserIsPending ? (
              <Skeleton className='h-8 w-40' />
            ) : (
              <h2 className="text-2xl font-bold">
                {clientUserData?.full_name || '--'}
              </h2>
            )}
          </div>

          {!currentTab && (
            <div className="flex gap-4">
              {!clientUserIsPending && userId !== 'me' && (
                <Link
                  to={disableUpdateButton ? '' : `/users/${userId}/edit`}
                  className={disableUpdateButton ? 'cursor-default' : ''}
                >
                  <Button className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]" disabled={disableUpdateButton}>
                    Editar
                  </Button>
                </Link>
              )}
            </div>
          )}
        </div>

        <Tabs
          tabsListClassName="w-full bg-transparent rounded-none"
          tabsTriggerClassName="h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
          tabsContentClassName="mt-6"
          tabsList={tabsList}
          isLoading={companyDataIsPending}
          skeletonsCount={4}
        />
      </div>
    </ErrorMessageWrapper>
  );
};

export default Show;
